import React from 'react'
import "./loading.scss";


const Loading = () => {
  return (
    <div className='loadDiv'>
    <div className='load'>
      <h1>Loading...</h1>
    </div>
    </div>
  )
}

export default Loading;